import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reward_alert",
  "use": "icon-reward_alert-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-reward_alert\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-2h24v24H-2z\" /><path d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10ZM9 9v6h2V9H9Zm0-4v2h2V5H9Z\" fill=\"#0FBA57\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol